import { Divider } from "antd"
import _ from "underscore"
import React, { useLayoutEffect, useState } from "react"
import Loader from "./CommonComponents/Loader"
import { TruncateText } from "../utilities"

const ConversationHistory = ({ setActiveView, setConvMessages }) => {
  const [conversations, setConversations] = useState({})
  const [loading, setLoading] = useState(true)

  const groupByDate = (items) => items.reduce((acc, conv) => {
    const date = conv.created_at
    if (!acc[date]) acc[date] = []
    acc[date].push(conv)
    return acc
  }, {})

  useLayoutEffect(() => {
    APIClient.get("/conversations/recent", (response) => {
      if (response.conversations.length > 0) {
        const grouped = groupByDate(response.conversations)
        setConversations(grouped)
      }
      setLoading(false)
    })
  }, [])

  if (loading) {
    return <Loader />
  }

  if (_.isEmpty(conversations)) {
    return (
      <div className="no-chat-available">
        <span className="no-chat-available-text">No History Available</span>
      </div>
    )
  }
  return (
    <div className="space-y-6 p-2">
      {Object.entries(conversations).map(([date, convs]) => (
        <>
          <div key={date} className="space-y-2">
            <div>
              <span className="chat-title-date">{date}</span>
            </div>
            <div
              key={convs.id}
              className="convos-gap"
              onClick={() => {
                setActiveView("chat")
              }}
            >
              {convs.map((conv) => (
                <div
                  key={conv.id}
                  className="chat-color rounded-lg shadow-sm p-2 flex justify-between d-flex flex-column"
                  onClick={() => {
                    setConvMessages(conv.id)
                    localStorage.setItem("conversation_id", conv.id)
                    localStorage.setItem("conversation_date", conv.created_at)
                  }}
                >
                  <div>
                    <span>{TruncateText(conv.title, 50)}</span>
                  </div>
                  <div className="d-flex justify-content-end">
                    <span style={{ color: "#4f4f4f", fontWeight: "bold" }}>
                      {conv.conversation_start_time}
                    </span>
                  </div>{" "}
                </div>
              ))}
            </div>
          </div>
          <Divider />
        </>
      ))}
    </div>
  )
}

export default ConversationHistory
